export default __webpack_public_path__ + "static/media/creator.7762046e.png";